import { render } from "./scriptMatching.vue?vue&type=template&id=622ab352&scoped=true"
import script from "./scriptMatching.vue?vue&type=script&lang=js"
export * from "./scriptMatching.vue?vue&type=script&lang=js"

import "./scriptMatching.vue?vue&type=style&index=0&id=622ab352&lang=scss&scoped=true"
import "./scriptMatching.vue?vue&type=style&index=1&id=622ab352&lang=scss"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622ab352"]])

export default __exports__